import styled from 'styled-components';

export const StyledVoiceSelect = styled.div`
  background: transparent;
  height: ${({ theme }) => theme.smallButtonSize};
  min-height: ${({ theme }) => theme.smallButtonSize};
  width: 100%;
  cursor: ${({ $disabled }) => $disabled ? undefined : 'pointer'};
  padding: 2px;
  position: relative;
  opacity: ${({ $disabled }) => $disabled ? '0.4' : '1.0'};

  &:hover {
    .voice-select-button-corner {
      border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected, $disabled }) => $selected ? 'white' : $disabled ? 'transparent' : 'white'};
    }

    .voice-select-button-corner-l {
      border-right: none;
    }

    .voice-select-button-corner-r {
      border-left: none;
    }
  }

  .voice-select-button {
    border: solid 2px rgba(0, 0, 0, .16);
    cursor: ${({ $disabled }) => $disabled ? undefined : 'pointer'};
    color: black;
    background: ${({ theme }) => theme.buttonGreen};
    width: 100%;
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 1.25rem;
    line-height: 1.4rem;
    font-weight: 700;
    padding: 3px 8px 3px 5px;
    height: 100%;
    min-height: 100%;
    width: 100%;
    min-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    transition: linear 0.2s;

    @media (max-width: ${({ theme }) => theme.mobile}) {
      border-width: 1px;
      font-weight: 400;
      padding: 0;
    }

    &:hover {
      background: ${({ theme, $disabled }) => $disabled ? theme.buttonGreen : theme.buttonLightGreen};
      border-color: ${({ theme, $disabled }) => $disabled ? 'rgba(0, 0, 0, .16)' : theme.buttonDarkGreen};
    }
  }

  .voice-select-button-corner {
    position: absolute;
    border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? 'white' : 'transparent'};
    top: 0;
    bottom: 0;
    width: 8px
  }

  .voice-select-button-corner-l {
    border-right: none;
    left: 0;
  }

  .voice-select-button-corner-r {
    border-left: none;
    right: 0;
  }

  .voice-select-dropdown {
    border: solid 4px ${({ theme }) => theme.traitBorder};
    position: absolute;
    margin-left: -2px;
    padding: 4px;
    z-index: 1;
    background: ${({ theme }) => theme.background};
    width: calc(${({ theme }) => theme.hudPanelWidth} - 2 * 35px); 
    left: 0;
    max-height: calc(${({ theme }) => theme.smallButtonSize} * 8 + 7 * 4px);
    overflow-y: auto;
    bottom: calc(${({ theme }) => theme.smallButtonSize} + 16px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    animation: popup-animation-translate 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0s 1 normal forwards, popup-animation-opacity 0.1s cubic-bezier(0.5, 0.35, 0, 1) 0s 1 normal forwards;
    -webkit-backdrop-filter: blur(10px);
    -moz-backdrop-filter: blur(10px);
    -ms-backdrop-filter: blur(10px);
    -o-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  .voice-select-arrow {
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    width: 4px;
    height: 4px;
    min-width: 4px;
    min-height: 4px;
    max-width: 4px;
    max-height: 4px;
    margin-bottom: 6px;
    transition: linear 0.2s;
    transform: ${({ $show }) => $show ? 'rotate(-135deg)' : 'rotate(45deg)'};
    -webkit-transform: ${({ $show }) => $show ? 'rotate(-135deg)' : 'rotate(45deg)'};
  }

  .voice-select-button-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

